import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import resume from '../../../imeges/Md Al Amin resume.pdf'

const Navber = () => {
    return (
        <div>
            <div className="navbar bg-base-100 fixed">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <li><AnchorLink href='#banner'>Home</AnchorLink> </li>
                            <li><AnchorLink href='#skills'>Skills</AnchorLink> </li>
                            <li><AnchorLink href='#about'>About Us</AnchorLink> </li>
                            <li><AnchorLink href='#project'>Project</AnchorLink> </li>
                            <li><AnchorLink href='#contact'>Contact Us</AnchorLink> </li>
                        </ul>
                    </div>
                    <AnchorLink href='#banner' className="btn btn-ghost normal-case text-xl">Al Amin</AnchorLink>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1 font-semibold">
                        <li><AnchorLink href='#banner'>Home</AnchorLink> </li>
                        <li><AnchorLink href='#skills'>Skills</AnchorLink> </li>
                        <li><AnchorLink href='#about'>About Us</AnchorLink> </li>
                        <li><AnchorLink href='#project'>Project</AnchorLink> </li>
                        <li><AnchorLink href='#contact'>Contact Us</AnchorLink> </li>

                    </ul>
                </div>
                <div className="navbar-end">
                    <a href='https://drive.google.com/file/d/1AbCEaUhXj4cA7eWP9v7wSB78bI8Y_cVx/view?usp=sharing' className="btn" target="_blank">View Resume</a>
                </div>
            </div>

        </div>
    );
};

export default Navber;